import { IBusiness, ICategory } from 'src/models';

import { ITreeObj, OrderEditType, TOrderEditType } from '../../components/orderEditTypes';

// 카테고리 데이터를 트리 아이템으로 변환하는 함수 + 비즈니스
const convertMenusToTreeItems = (
  type: TOrderEditType,
  categoryTree: ICategory[],
  businessData: IBusiness[],
  selectedLang: string,
): ITreeObj[] => {
  // null 체크 추가
  if (!categoryTree) return [];
  // 현재 설정된 언어
  const currentLangCd = selectedLang ?? localStorage.getItem('i18nextLng');

  // 트리 데이터 생성
  const buildTree = (items: ICategory[], parentSid: number | null): any[] => {
    return items
      .filter((item) => item.categoryPsid === parentSid)
      .map((item) => {
        // 비즈니스 타입일 때만 비즈니스 노드 추가
        const relatedBusinesses =
          type === OrderEditType.BUSINESS
            ? businessData
                .filter((business) => business.categorySid === item.categorySid)
                .map((business) => ({
                  id: `business-${business.businessSid}`,
                  name: business.title || '',
                  isBusiness: true,
                  useYn: business.useYn,
                }))
            : [];
        return {
          id: item.categorySid?.toString(),
          name:
            item.categoryInfoList?.find((info) => info.langCd === currentLangCd)?.categoryNm ?? '',
          children: [
            ...(item.children
              ? buildTree(item.children, item.categorySid)
              : buildTree(items, item.categorySid)),
            ...(type === OrderEditType.BUSINESS ? relatedBusinesses : []), // 비즈니스 타입일 때만 추가
          ],
          useYn: item.useYn,
        };
      });
  };
  return buildTree(categoryTree, null);
};

export default convertMenusToTreeItems;
